import Skeleton from '@mui/material/Skeleton';
import type React from 'react';
import InlineCardActions from '../../AkomiMediaCardInline/InlineCardActions';
import { useListViewRowContext } from '../ListViewRowContext';

const ActionsCell: React.FC = () => {
  const { loading, rowType, itemId, permissions } = useListViewRowContext();

  if (loading) {
    return <Skeleton variant="circular" width={20} height={20} animation="wave" sx={{ mx: 'auto' }} />;
  }

  if (rowType === 'asset' && itemId) {
    return <InlineCardActions itemID={itemId} permissions={permissions} />;
  }

  return null;
};

export default ActionsCell;
